import apiSlice from "../features/apiSlice";
import { removeEmptyKeys } from "../utils/helper";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCreative: builder.query({
      query: (queries) => {
        return {
          url: '/creative',
          params: removeEmptyKeys(queries),
        };
      },
      providesTags: ['Creative']
    }),
    getCreativeById: builder.query({
      query: (id) => {
        return {
          url: `/creative/id/${id}`,
        };
      },
      providesTags: ['Creative'],
    }),
    getCreativeUser: builder.query({
      query: (queries) => {
        return {
          url: '/creative/filterCreative',
          params: removeEmptyKeys(queries),
        };
      },
      providesTags: ['Creative'],
      async onQueryStarted(
        arg,
        {
          dispatch,
          getState,
          extra,
          requestId,
          queryFulfilled,
          getCacheEntry,
          updateCachedData,
        },
      ) { },
      // The 2nd parameter is the destructured `QueryCacheLifecycleApi`
      async onCacheEntryAdded(
        arg,
        {
          dispatch,
          getState,
          extra,
          requestId,
          cacheEntryRemoved,
          cacheDataLoaded,
          getCacheEntry,
          updateCachedData,
        },
      ) { }
    }),
    createCreative: builder.mutation({
      query: (credentials) => ({
        url: "/creative",
        method: "POST",
        body: credentials,
      }),
      invalidatesTags: ['Creative'],
    }),
    updateCreative: builder.mutation({
      query: (credentials) => ({
        url: `/creative/${credentials.id}`,
        method: "PUT",
        body: credentials.body,
      }),
      invalidatesTags: ['Creative'],
    }),
    bulkUpdateCreative: builder.mutation({
      query: (credentials) => ({
        url: `/creative/updateMany`,
        method: "POST",
        body: credentials,
      }),
      invalidatesTags: ['Creative'],
    }),
    deleteCreative: builder.mutation({
      query: (credentials) => ({
        url: `/creative/${credentials.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ['Creative'],
    }),
    hardDeleteCreative: builder.mutation({
      query: (credentials) => ({
        url: `/creative/hardDelete/${credentials.id}`,
        method: "DELETE",
        body: credentials.body,
      }),
      invalidatesTags: ['Creative'],
    }),
  }),
});

export const {
  useGetCreativeQuery,
  useGetCreativeByIdQuery,
  useGetCreativeUserQuery,
  useLazyGetCreativeUserQuery,
  useLazyGetCreativeQuery,
  useCreateCreativeMutation,
  useUpdateCreativeMutation,
  useBulkUpdateCreativeMutation,
  useDeleteCreativeMutation,
  useHardDeleteCreativeMutation
} = authApiSlice;
